import { z } from "zod";

export const schema = z.object({
  reason: z
    .string()
    .min(1, "La razón es obligatoria")
    .max(120, "La longitud máxima de la razón es de 120 caracteres")
    .refine((val) => {
      return val.trim().length > 0;
    }, "La razón no puede estar vacía"),
});

export type DenyCorrectionFormData = z.infer<typeof schema>;

export const optionalSchema = z.object({
  reason: z
    .string()
    .max(5000, "La longitud máxima de la razón es de 5000 caracteres")
    .optional()
    .refine((val) => {
      if (!val) return true;
      return val.trim().length > 0;
    }, "La razón no puede estar vacía"),
});

export type OptionalDenyCorrectionFormData = z.infer<typeof optionalSchema>;
